import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search } from 'lucide-react';
import { businessSupplierService } from '../../../services/businessApi';
import { useAuth } from '../../../context/AuthContext';
import SupplierFormModal from './SupplierFormModal';
import '../../../styles/businessTheme.css';
import '../Checklist/Checklist.css'; // .checklist-supplier-name / .checklist-supplier-code
import './SuppliersList.css';

// The one canonical place suppliers get created and edited (per the redesign) — the
// Checklist page and ticket form both just search against what's created here.
export default function SuppliersList() {
  const { isBusinessLead } = useAuth();
  const [suppliers, setSuppliers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await businessSupplierService.search();
    setSuppliers(res.data.suppliers);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = suppliers.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.vendorCode.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="suppliers-list-page biz-theme biz-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Suppliers</h1>
          <p className="page-subtitle">{suppliers.length} supplier{suppliers.length !== 1 ? 's' : ''} on record</p>
        </div>
        {isBusinessLead && (
          <button className="btn btn-primary" onClick={() => setShowCreate(true)}>
            <Plus size={14} /> Add Supplier
          </button>
        )}
      </div>

      <div className="suppliers-toolbar">
        <div className="search-box">
          <Search size={14} />
          <input placeholder="Search by name or vendor code..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      <div className="card suppliers-table">
        <table>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Contact</th>
              <th>Plants</th>
              <th>Source</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(s => (
              <tr key={s._id}>
                <td>
                  <div className="checklist-supplier-name">{s.name}</div>
                  <div className="checklist-supplier-code">{s.vendorCode}</div>
                </td>
                <td className="suppliers-contact-cell">
                  {s.contactPerson && <div>{s.contactPerson}</div>}
                  {s.contactEmail && <div>{s.contactEmail}</div>}
                  {s.contactPhone && <div>{s.contactPhone}</div>}
                  {!s.contactPerson && !s.contactEmail && !s.contactPhone && '—'}
                </td>
                <td>{s.plantCount}</td>
                <td><span className="suppliers-source">{s.createdVia}</span></td>
                <td>
                  <Link to={`/business/suppliers/${s._id}`} className="btn btn-ghost btn-sm">View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && filtered.length === 0 && <div className="empty-state">No suppliers found</div>}
      </div>

      {showCreate && (
        <SupplierFormModal
          onClose={() => setShowCreate(false)}
          onSaved={() => { setShowCreate(false); load(); }}
        />
      )}
    </div>
  );
}
